import type { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton';
import MuiSkeleton from '@mui/material/Skeleton';
import type { SxProps } from '@mui/system';
import React from 'react';

interface SkeletonProps {
  variant?: MuiSkeletonProps['variant'];
  height?: number;
  width?: number;
  sx?: SxProps;
}

const Skeleton: React.FC<SkeletonProps> = ({ variant, sx } = { variant: 'text' }) => (
  <MuiSkeleton sx={{ bgcolor: 'grey.900', ...sx }} variant={variant} />
);

export default Skeleton;
